import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faFileAlt } from '@fortawesome/pro-regular-svg-icons/faFileAlt';

import { convertPermalinkToPath } from '../../../../../../helpers/urlHelpers';

import Tooltip from '../../../../../Tooltip';
import TransparentButton from '../../../../../Buttons/PreferencesButtons/TransparentButton';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const TabTableSection = (props) => {
  const {
    currentPage, pageSize, currentData, hasInsightsAccess,
  } = props;
  const tableBodyRef = useRef();

  return (
    <div className={cx('corporate-actions', { new_loading: currentData.newLoading, no_access: !hasInsightsAccess })}>
      <div className={Styles['corporate-actions-header']}>
        <div className={Styles['corporate-actions-row']}>
          <div className={cx('corporate-actions-cell', 'rowNumber')}>#</div>
          <th className={cx('corporate-actions-cell', 'filingDate')}>Filing Date</th>
          <th className={cx('corporate-actions-cell', 'filingType')}>Filing Type</th>
          <th className={cx('corporate-actions-cell', 'description')}>Description</th>
          <div className={cx('corporate-actions-cell', 'expandIcon')} />
        </div>
      </div>
      {!hasInsightsAccess && (
        <div className={Styles['corporate-actions-access']}>
          <Link to="/pricing">Upgrade to UK Insights</Link>
          {' '}
          to use this feature.
        </div>
      )}
      <div className={Styles['corporate-actions-body']} ref={tableBodyRef}>
        {currentData.data
          .map((obj, i) => (
            <TableRow
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              currentData={obj}
              currentRow={((currentPage - 1) * pageSize) + (i + 1)}
            />
          ))}
      </div>
    </div>
  );
};

const TableRow = (props) => {
  const { currentData, currentRow } = props;
  const [isExpand, setIsExpand] = useState(false);

  return (
    <div className={cx('corporate-actions-row-holder')}>
      <div className={Styles['corporate-actions-row']}>
        <div className={cx('corporate-actions-cell', 'rowNumber')}>
          {currentRow}
        </div>
        <div className={cx('corporate-actions-cell', 'filingDate')}>
          {currentData.filingInformation?.filingDate ? moment(currentData.filingInformation?.filingDate, 'YYYY-MM-DD').format('DD MMM YYYY') : '-'}
        </div>
        <div className={cx('corporate-actions-cell', 'filingType')}>
          {currentData.filingInformation?.filingType || '-'}
          <Tooltip
            hasBigScreenDesign
            className={Styles.infoIcon_tooltip}
            icon={(
              <Link
                className={Styles.infoIcon}
                to={convertPermalinkToPath(currentData.cfUrl)}
              >
                <FontAwesomeIcon icon={faFileAlt} />
              </Link>
            )}
          >
            View document
          </Tooltip>
        </div>
        <div className={cx('corporate-actions-cell', 'description')}>
          {currentData.description || '-'}
        </div>
        <div
          className={cx('corporate-actions-cell', 'expandIcon')}
          onClick={() => setIsExpand(!isExpand)}
        >
          <FontAwesomeIcon icon={isExpand ? faChevronUp : faChevronDown} />
        </div>
      </div>
      {isExpand && (
      <div className={cx('corporate-actions-extra')}>
        <div className={cx('corporate-actions-extra-row')}>
          <div className={cx('corporate-actions-extra-cell', 'date')}>
            <div className={cx('corporate-actions-extra-title')}>
              Description
            </div>
            <div className={cx('corporate-actions-extra-value')}>
              {currentData.description || '-'}
            </div>
          </div>
        </div>
        <div className={cx('corporate-actions-extra-footer')}>
          <TransparentButton
            type="anchor"
            noHover
            to={currentData.cfUrl && convertPermalinkToPath(currentData.cfUrl)}
            external={false}
            className={cx('filling-btn')}
          >
            View Document
          </TransparentButton>
        </div>
      </div>
      )}
    </div>
  );
};

export default TabTableSection;
